module.exports = __webpack_public_path__ + "static/media/blueDartThrown.d10c9d96.svg";